import { ReactElement } from 'react'
import PagamentoRepository from 'modules/pagamentos/infra/repositories/PagamentoRepository'
import VerifyPasswordImpl from '../../domain/usecases/VerifyPassword'
import GetCartoes from '../../domain/usecases/GetCartoes'
import PagamentoNew from '../../pages/PagamentoNew'

export const PagamentoNewFactory = (): ReactElement => {
  const pagamentoRepository = new PagamentoRepository()
  const getCartao = new GetCartoes(pagamentoRepository)
  const verifyPassword = new VerifyPasswordImpl(pagamentoRepository)

  return <PagamentoNew getCartao={getCartao} verifyPassword={verifyPassword} />
}
